<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>Email Authentication</p>
    </div>
    <div class="card">
        <div class="card-inner">
            <div v-if="!response.duplicated_email" class="question-wrap _t-center">
                <h3><span>{{ response.mes }}</span></h3>
            </div>
            <div v-if="response.duplicated_email" class="question-wrap _t-center">
                <h3><span>登録しようとしたメールアドレスは</span></h3>
                <h3><span>既に他のアカウントへ登録済みです。</span></h3>
            </div>
            <div v-if="response.duplicated_email" class="question-wrap _t-center">
                <p>
                    <span>
                        ＜サービスの利用＞<br/>
                        ・登録済のアカウントでご利用ください。
                    </span>
                </p><br/>
                <p>
                    <span>
                        ＜ID／パスワードがわからない場合＞<br/>
                        ・再設定をし、あらためてログインしてください。<br/>
                        ※ID／パスワードの再設定は<a href="/forgot-password">こちら</a>。
                    </span>
                </p><br/>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        props: {
            response: Object
        },
    };
</script>
